import { PageHeader } from "./page-header";

interface ListPageProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: { label: string; href?: string }[];
  actions?: React.ReactNode;
  /** Optional ViewSwitcher (or similar) rendered between header and filters. */
  tabs?: React.ReactNode;
  filters?: React.ReactNode;
  /** Optional aggregate strip rendered immediately above children/DataTable. */
  aggregateStrip?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Canonical list-page shell. Slot order is fixed:
 *   PageHeader → tabs → filters → aggregateStrip → children
 *
 * `aggregateStrip` deliberately sits flush against `children` so the strip's
 * top-rounded / bottom-flat radius composes with a DataTable's top border.
 */
export function ListPage({
  title,
  subtitle,
  breadcrumbs,
  actions,
  tabs,
  filters,
  aggregateStrip,
  children,
}: ListPageProps) {
  const crumbs = breadcrumbs ?? [{ label: title }];
  return (
    <>
      <PageHeader
        breadcrumbs={crumbs}
        title={title}
        subtitle={subtitle}
        actions={actions}
      />
      {tabs && <div className="mb-3">{tabs}</div>}
      {filters && <div className="mb-4">{filters}</div>}
      {aggregateStrip}
      {children}
    </>
  );
}
